import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Col } from '../../util_grid/grid.js';
import Icon from '../../base_svg-icon/component';
import { Button } from 'audamatic-ui';
import './styles/styles.scss';

const Sidepanel = (props) => {
  const {
    className = '',
    title = '',
    location = '',
    component = null,
    style = null,
    toggled = false,
    componentNotRendered: ComponentNotRenderedYet,
    closeModal,
  } = props;

  const [hasScrolled, setHasScrolled] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    const checkScrollPosition = () => {
      if (hasScrolled && el.scrollTop === 0) {
        setHasScrolled(false);
      } else if (!hasScrolled && el.scrollTop > 0) {
        setHasScrolled(true);
      }
    };

    el.addEventListener('scroll', checkScrollPosition);
    return () => el.removeEventListener('scroll', checkScrollPosition);
  }, [hasScrolled]);

  return (
    <Col
      xs={12}
      id="page-content-wrapper"
      className={`nooverflow ${toggled ? 'sidepanel-open' : ''}`}
    >
      <div className={`sidepanel ${location}`}>
        <div className={`sidepanel-content ${className}`} style={style}>
          <div className={`sidepanel-header ${hasScrolled ? 'scrolled' : ''}`}>
            <h2>
              <span>{title}</span>
              <Button
                variant="linkPrimary"
                size="large"
                iconLeft={<Icon name="ico-error" />}
                onClick={closeModal}
                data-test-id="closeSidepanel"
              />
            </h2>
          </div>
          <div ref={contentRef} className="sidepanel-component">
            {!!ComponentNotRenderedYet ? (
              <ComponentNotRenderedYet
                className={className}
                style={style}
                toggled={toggled}
                title={title}
                location={location}
                closeModal={closeModal}
              />
            ) : (
              component
            )}
          </div>
        </div>
        <span onClick={closeModal} className="sidepanel-shade" />
      </div>
    </Col>
  );
};

Sidepanel.propTypes = {
  /** Boolean if the sidepanel is shown or not */
  toggled: PropTypes.bool,
  /** Location of the sidepanel (e.g. 'left' or 'right') */
  location: PropTypes.string,
  /** Title inside the sidepanel */
  title: PropTypes.string,
  /** Rendered component */
  component: PropTypes.object,
  /** Component type not yet rendered */
  componentNotRendered: PropTypes.any,
  closeModal: PropTypes.func,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default Sidepanel;
